import React, { ReactNode } from "react"
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { Content, Group, Icon, Item, ItemText, Label, Portal, ScrollDownButton, ScrollUpButton, Select, Separator, Trigger, Value, Viewport } from "./style"

type SelectItemProps = {
    children: ReactNode;
    value: string;
}

function SelectItem({children, value}: SelectItemProps) {
    return (
        <Item value={value}>
            <ItemText>
                {children}
            </ItemText>
        </Item>
    )
}

export function FilterSelect() {
    return (
        <Select>
            <Trigger aria-label="Filter method">
                <Value placeholder="Filtrar por..." />
                <Icon>
                    <FaAngleDown size={17} />
                </Icon>
            </Trigger>

            <Portal>
                <Content>
                    <ScrollUpButton>
                        <FaAngleUp size={16} />
                    </ScrollUpButton>

                    <Viewport>
                        <Group>
                            <Label>Escolha um filtro</Label>

                            <Separator />

                            <SelectItem value="anything">Qualquer coisa</SelectItem>
                            <SelectItem value="label">Categoria</SelectItem>
                            <SelectItem value="title">Título</SelectItem>
                            <SelectItem value="author">Autor</SelectItem>
                        </Group>
                    </Viewport>

                    <ScrollDownButton>
                        <FaAngleDown size={16} />
                    </ScrollDownButton>
                </Content>
            </Portal>
        </Select>
    )
}